import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useWaiver} from 'Event/Step2/Waivers/Waiver'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import TextEditor, {TextEditorContainer} from 'lib/ui/form/TextEditor'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function BodyConfig() {
  const {
    form: {control},
  } = useConfig()
  const {waiver, id} = useWaiver()

  const addTranslation = useAddTranslation()
  const v = useAttendeeVariables()

  const save = useSaveTemplate()

  const handleSave = (data: any) => {
    const body = replaceAtPath(
      data,
      `waiver.targets.${id}.body`,
      '{{waiver_body}}',
    )

    // Filter out waiver.targets if it's an array to prevent sending massive arrays
    // The template provider should normalize it, but this is a safety check
    const saveData: any = {...data}
    if (saveData.waiver?.targets && Array.isArray(saveData.waiver.targets)) {
      delete saveData.waiver.targets
    }

    save({
      ...saveData,
      localization: addTranslation({
        waiver_body: body ?? '',
      }),
    })
  }

  return (
    <Config title="Body" onSave={handleSave}>
      <SettingsPanel>
        <TextEditorContainer>
          <Controller
            name={`waiver.targets.${id}.body`}
            defaultValue={v(waiver.body)}
            control={control}
            render={({value, onChange}) => (
              <TextEditor data={value} onChange={onChange} />
            )}
          />
        </TextEditorContainer>
      </SettingsPanel>
    </Config>
  )
}
